import { DatePipe } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { PointLineStringVehiculo } from '../../../../interfaces';
import { ItemCategoria } from '../lista-categoria/lista-categoria.component';

/**
 * Excesos de velocidad del viaje. Mapea los puntos a la categoría genérica; el
 * armazón y el estilo son de app-lista-categoria.
 *
 * Presentacional: no calcula nada ni conoce el estado del mapa, sólo emite el
 * punto elegido.
 */
@Component({
  selector: 'app-lista-excesos',
  templateUrl: './lista-excesos.component.html',
  styleUrl: './lista-excesos.component.scss',
  standalone: false,
})
export class ListaExcesosComponent {
  private fecha = new DatePipe('es-AR');

  @Input() set excesos(value: PointLineStringVehiculo[] | undefined) {
    this._excesos = value ?? [];
    this.actualizarItems();
  }
  get excesos(): PointLineStringVehiculo[] {
    return this._excesos;
  }
  private _excesos: PointLineStringVehiculo[] = [];

  /** Velocidad a partir de la cual se contó el exceso, para mostrarla. */
  @Input() set velocidadMinima(value: number | null | undefined) {
    this._velocidadMinima = value;
  }
  get velocidadMinima(): number | null | undefined {
    return this._velocidadMinima;
  }
  private _velocidadMinima?: number | null;

  /** Los excesos se están calculando. */
  @Input() cargando = false;

  @Output() seleccionar = new EventEmitter<PointLineStringVehiculo>();

  public items: ItemCategoria<PointLineStringVehiculo>[] = [];

  public get umbral(): string | undefined {
    return this.velocidadMinima ? `≥${this.velocidadMinima} km/h` : undefined;
  }

  // El Output de la categoría no es genérico (los templates no propagan el
  // tipo), así que el dato vuelve como unknown y se castea acá.
  public verEnMapa(item: ItemCategoria): void {
    const exceso = item.dato as PointLineStringVehiculo | undefined;
    if (exceso) this.seleccionar.emit(exceso);
  }

  private actualizarItems(): void {
    // Del más rápido al más lento: es el orden en el que se los mira
    this.items = [...this._excesos]
      .sort((a, b) => (b.velocidad ?? 0) - (a.velocidad ?? 0))
      .map((exceso) => ({
        id: `${exceso.fechaDevice}_${exceso.velocidad}`,
        titulo:
          this.fecha.transform(exceso.fechaDevice, 'dd/MM/yyyy HH:mm') ?? '',
        descripcion: `${Math.round(exceso.velocidad ?? 0)} km/h`,
        colorDescripcion: '#ef5350',
        detalles: [
          {
            label: 'Velocidad',
            valor: `${Math.round(exceso.velocidad ?? 0)} km/h`,
            icono: 'speed',
          },
          {
            label: 'Hora',
            valor: this.fecha.transform(exceso.fechaDevice, 'HH:mm:ss') ?? '',
            icono: 'schedule',
          },
        ],
        nota: exceso.address,
        dato: exceso,
      }));
  }
}
